import { motion } from "framer-motion";
import { Image, Camera, FileText } from "lucide-react";

/**
 * AttachmentMenu - قائمة المرفقات
 * @param {Function} onClose - إغلاق القائمة
 * @param {Function} t - دالة الترجمة
 */
export function AttachmentMenu({ onClose, t }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 10, scale: 0.95 }}
      className="absolute bottom-full mb-2 right-4 bg-card border border-border rounded-xl shadow-lg p-2 flex flex-col gap-1 min-w-[160px]"
    >
      <label
        htmlFor="image-input"
        onClick={onClose}
        className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-secondary text-sm text-foreground transition-colors cursor-pointer"
      >
        <Image className="w-4 h-4 text-blue-500" />
        <span>{t("imageFromGallery")}</span>
      </label>
      <label
        htmlFor="camera-input"
        onClick={onClose}
        className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-secondary text-sm text-foreground transition-colors cursor-pointer"
      >
        <Camera className="w-4 h-4 text-green-500" />
        <span>{t("takePhoto")}</span>
      </label>
      <label
        htmlFor="file-input"
        onClick={onClose}
        className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-secondary text-sm text-foreground transition-colors cursor-pointer"
      >
        <FileText className="w-4 h-4 text-orange-500" />
        <span>{t("analyzeFile")}</span>
      </label>
    </motion.div>
  );
}

export default AttachmentMenu;
